import { Printable } from "../types";
import { candyPanner } from "./candy-panner";
import { skateboardHolder } from "./skateboard-holder";

export const objects: Printable[] = [candyPanner, skateboardHolder];
